export const IdentitySearchFormFields = {
  ssn: 'ssn',
  last4Ssn: 'last4Ssn',
  firstName: 'firstName',
  lastName: 'lastName',
  birthDate: 'birthDate',
} as const;
